import produce from "immer";
import { DATE_FORMATS } from "../interfaces";
export const numericComparator = (num1, num2) => {
    if (num1 === null && num2 === null) {
        return 0;
    }
    if (num1 === null) {
        return -1;
    }
    if (num2 === null) {
        return 1;
    }
    return num1 - num2;
};
export const createFocusErrors = (errorArray) => {
    let focusErrors = {};
    for (let i = 0; i < errorArray.length; i++) {
        const { dataPath, keyword } = errorArray[i];
        let { message } = errorArray[i];
        if (keyword === "if")
            continue;
        let auxFocusErrors = focusErrors;
        let errorMessage = message;
        if (message.includes("should match format")) {
            let messageTokens = message.split('"');
            switch (messageTokens[1]) {
                case DATE_FORMATS.DAY_ABS:
                    errorMessage = messageTokens[0] + '"yyyy/MM/dd"';
                    break;
                case DATE_FORMATS.DAY_REL:
                    errorMessage = messageTokens[0] + '"MM/dd"';
                    break;
                case DATE_FORMATS.MIC_ABS:
                    errorMessage = messageTokens[0] + '"yyyy/MM/dd-HH:mm:ss.uuuuuu"';
                    break;
                case DATE_FORMATS.MIC_REL:
                    errorMessage = messageTokens[0] + '"MM/dd-HH:mm:ss.uuuuuu"';
                    break;
                case DATE_FORMATS.SEC_ABS:
                    errorMessage = messageTokens[0] + '"yyyy/MM/dd-HH:mm:ss"';
                    break;
                case DATE_FORMATS.SEC_REL:
                    errorMessage = messageTokens[0] + '"MM/dd-HH:mm:ss"';
                    break;
                case DATE_FORMATS.SEC_ABS_DOT:
                    errorMessage = messageTokens[0] + '"yyyy/MM/dd-HH:mm:ss."';
                    break;
                case DATE_FORMATS.SEC_REL_DOT:
                    errorMessage = messageTokens[0] + '"MM/dd-HH:mm:ss.SSS."';
                    break;
                case DATE_FORMATS.STD_ABS:
                    errorMessage = messageTokens[0] + '"yyyy/MM/dd-HH:mm:ss.SSS"';
                    break;
                case DATE_FORMATS.STD_REL:
                    errorMessage = messageTokens[0] + '"MM/dd-HH:mm:ss.SSS"';
                    break;
            }
        }
        let tokens = dataPath.slice(1).split(".");
        for (let j = 0; j < tokens.length; j++) {
            let token = tokens[j];
            if (j != tokens.length - 1) {
                if (token.includes("[")) {
                    let tokenRows = token.split("[");
                    token = tokenRows[0];
                    let rowNumber = parseInt(tokenRows[1].slice(0, -1)) + 1;
                    errorMessage = message + " (Row " + rowNumber + ")";
                }
                if (token === token.toUpperCase()) {
                    if (!(token in auxFocusErrors)) {
                        auxFocusErrors[token] = { errors: [] };
                    }
                    auxFocusErrors = auxFocusErrors[token];
                }
            }
            else {
                if (token.includes("[")) {
                    let tokenRows = token.split("[");
                    let columnToken;
                    token = tokenRows[0];
                    if (tokenRows.length === 3) {
                        columnToken = parseInt(tokenRows[2].slice(0, -1)) + 1;
                    }
                    let rowNumber = parseInt(tokenRows[1].slice(0, -1)) + 1;
                    errorMessage = columnToken
                        ? message + " (Row " + rowNumber + " Column " + columnToken + ")"
                        : message + " (Row " + rowNumber + ")";
                }
                if (token !== token.toUpperCase()) {
                    if (!auxFocusErrors["errors"]) {
                        auxFocusErrors["errors"] = [];
                    }
                    auxFocusErrors["errors"].push(errorMessage);
                }
                else {
                    if (!(token in auxFocusErrors)) {
                        auxFocusErrors[token] = { errors: [] };
                    }
                    auxFocusErrors[token]["errors"].push(errorMessage);
                }
            }
        }
    }
    return focusErrors;
};
export function getUiProperties(uiSchema) {
    const isDisabled = !!(typeof uiSchema["ui:disabled"] !== "undefined" && uiSchema["ui:disabled"]);
    const isReadOnly = !!(typeof uiSchema["ui:readOnly"] !== "undefined" && uiSchema["ui:readOnly"]);
    const isHidden = !!(typeof uiSchema["ui:hidden"] !== "undefined" && uiSchema["ui:hidden"]);
    return { isDisabled, isReadOnly, isHidden };
}
export function getValueWithType(type, value) {
    switch (type) {
        case "number":
            return value !== "" ? parseFloat(value) : 0;
        case "integer":
            return value !== "" ? parseInt(value) : 0;
        default:
            return value;
    }
}
export const getHeaderUischema = (uiSchemaDir, item) => {
    let headerUiSchema = {};
    headerUiSchema = produce(uiSchemaDir, (copy) => {
        for (let prop in copy) {
            if (prop == "ui:order") {
                copy[prop] = copy[prop].filter((order) => order === item);
            }
            else if (prop != item) {
                delete copy[prop];
            }
        }
        return copy;
    });
    return headerUiSchema;
};
export const getHeaderSchema = (schemaDir, item) => {
    let dialogSchema = {};
    dialogSchema = produce(schemaDir, (copy) => {
        for (let prop in copy.properties) {
            if (prop !== item) {
                delete copy.properties[prop];
            }
        }
        copy.minProperties = 1;
        copy.additionalProperties = true;
        return copy;
    });
    return dialogSchema;
};
export const getHeaderData = (data, item) => {
    let headerFormData = {};
    headerFormData = produce(data, (copy) => {
        for (let prop in copy) {
            if (prop !== item) {
                delete copy[prop];
            }
        }
        return copy;
    });
    return headerFormData;
};
export const getColumnDataUpdated = (formData, field, uiSchema) => {
    let fieldKey = Object.keys(field);
    const order = uiSchema["ui:order"];
    let newData = produce(formData, (copy) => {
        for (const itemkey in order) {
            const item = uiSchema["ui:order"][itemkey];
            if (uiSchema[item]["ui:field"] === "tabfield") {
                for (const subitemkey in uiSchema[item]["ui:order"]) {
                    const subitem = uiSchema[item]["ui:order"][subitemkey];
                    if (uiSchema[item][subitem]["ui:field"] === "separator") {
                        for (const subseparatorkey in uiSchema[item][subitem]["ui:order"]) {
                            const subseparator = uiSchema[item][subitem]["ui:order"][subseparatorkey];
                            if (subseparator === fieldKey[0]) {
                                copy.forEach((element) => {
                                    element[item][subitem][subseparator] = field[subseparator];
                                });
                            }
                        }
                    }
                    else {
                        if (subitem === fieldKey[0]) {
                            copy.forEach((element) => {
                                element[item][subitem] = field[subitem];
                            });
                        }
                    }
                }
            }
            else if (uiSchema[item]["ui:field"] === "separator") {
                for (const subseparatorkey in uiSchema[item]["ui:order"]) {
                    const subseparator = uiSchema[item]["ui:order"][subseparatorkey];
                    if (subseparator === fieldKey[0]) {
                        copy.forEach((element) => {
                            element[item][subseparator] = field[subseparator];
                        });
                    }
                }
            }
            else {
                if (item === fieldKey[0]) {
                    copy.forEach((element) => {
                        element[item] = field[item];
                    });
                }
            }
        }
        return copy;
    });
    return newData;
};
export const buildHeaders = (uiSchema, items, formData, handleData, headerParams) => {
    const order = uiSchema["ui:order"];
    let colDefs = [];
    let headerName = "";
    let headerField = "";
    let headerData = {
        data: [],
        schema: [],
        uiSchema: [],
    };
    let position = 0;
    for (const itemkey in order) {
        const item = uiSchema["ui:order"][itemkey];
        if (uiSchema[item]["ui:field"] === "tabfield" &&
            !uiSchema[item]["ui:hidden"]) {
            for (const subitemkey in uiSchema[item]["ui:order"]) {
                const subitem = uiSchema[item]["ui:order"][subitemkey];
                if (uiSchema[item][subitem]["ui:field"] === "separator" &&
                    !uiSchema[item]["ui:hidden"]) {
                    for (const subseparatorkey in uiSchema[item][subitem]["ui:order"]) {
                        const subseparator = uiSchema[item][subitem]["ui:order"][subseparatorkey];
                        const itemProperties = items.properties[item].properties[subitem].properties[subseparator];
                        headerName = itemProperties.title;
                        headerField = uiSchema[item][subitem]["ui:order"][subseparatorkey];
                        headerData.uiSchema.push(getHeaderUischema(uiSchema[item][subitem], subseparator));
                        headerData.schema.push(getHeaderSchema(items.properties[item].properties[subitem], subseparator));
                        headerData.data.push(formData.length > 0
                            ? getHeaderData(formData[0][item][subitem], subseparator)
                            : undefined);
                        colDefs.push({
                            headerName,
                            minWidth: 100,
                            field: headerField,
                            valueGetter: handleData(itemProperties),
                            comparator: itemProperties.type === "number"
                                ? numericComparator
                                : undefined,
                            headerComponent: "CustomHeader",
                            headerComponentParams: {
                                setOpen: headerParams.setIsOpenDialog,
                                setSelectedColumn: headerParams.setSelectedColumn,
                                position,
                                disableEdition: headerParams.disableHeaderEdition,
                            },
                        });
                        position++;
                    }
                }
                else if (!uiSchema[item][subitem]["ui:hidden"]) {
                    const itemProperties = items.properties[item].properties[subitem];
                    headerData.uiSchema.push(getHeaderUischema(uiSchema[item], subitem));
                    headerData.schema.push(getHeaderSchema(items.properties[item], subitem));
                    headerData.data.push(formData.length > 0
                        ? getHeaderData(formData[0][item], subitem)
                        : undefined);
                    headerName = itemProperties.title;
                    headerField = uiSchema[item]["ui:order"][subitemkey];
                    colDefs.push({
                        headerName,
                        minWidth: 100,
                        field: headerField,
                        valueGetter: handleData(itemProperties),
                        comparator: itemProperties.type === "number" ? numericComparator : undefined,
                        headerComponent: "CustomHeader",
                        headerComponentParams: {
                            setOpen: headerParams.setIsOpenDialog,
                            setSelectedColumn: headerParams.setSelectedColumn,
                            position,
                            disableEdition: headerParams.disableHeaderEdition,
                        },
                    });
                    position++;
                }
            }
        }
        else if (uiSchema[item]["ui:field"] === "separator" &&
            !uiSchema[item]["ui:hidden"]) {
            for (const subseparatorkey in uiSchema[item]["ui:order"]) {
                const subseparator = uiSchema[item]["ui:order"][subseparatorkey];
                const itemProperties = items.properties[item].properties[subseparator];
                headerName = itemProperties.title;
                headerField = uiSchema[item]["ui:order"][subseparatorkey];
                headerData.uiSchema.push(getHeaderUischema(uiSchema[item], subseparator));
                headerData.schema.push(getHeaderSchema(items.properties[item], subseparator));
                headerData.data.push(formData.length > 0
                    ? getHeaderData(formData[0][item], subseparator)
                    : null);
                colDefs.push({
                    headerName,
                    minWidth: 100,
                    field: headerField,
                    valueGetter: handleData(itemProperties),
                    comparator: itemProperties.type === "number" ? numericComparator : undefined,
                    headerComponent: "CustomHeader",
                    headerComponentParams: {
                        setOpen: headerParams.setIsOpenDialog,
                        setSelectedColumn: headerParams.setSelectedColumn,
                        position,
                        disableEdition: headerParams.disableHeaderEdition,
                    },
                });
                position++;
            }
        }
        else if (!uiSchema[item]["ui:hidden"]) {
            const itemProperties = items.properties[item];
            headerName = itemProperties.title;
            headerField = order[itemkey];
            headerData.uiSchema.push(getHeaderUischema(uiSchema, item));
            headerData.schema.push(getHeaderSchema(items, item));
            headerData.data.push(formData.length > 0 ? getHeaderData(formData[0], item) : undefined);
            colDefs.push({
                headerName,
                minWidth: 100,
                field: headerField,
                valueGetter: handleData(itemProperties),
                comparator: itemProperties.type === "number" ? numericComparator : undefined,
                headerComponent: "CustomHeader",
                headerComponentParams: {
                    setOpen: headerParams.setIsOpenDialog,
                    setSelectedColumn: headerParams.setSelectedColumn,
                    position,
                    disableEdition: headerParams.disableHeaderEdition,
                },
            });
            position++;
        }
    }
    return { columnsData: headerData, colDefs };
};
export const setNumberToLength = (num, maxLength) => {
    const excess = num.toExponential().length - maxLength;
    const toExponentialExcess = num.toExponential(maxLength).length - maxLength;
    if (num.toString().length > maxLength)
        return excess > 0
            ? num.toExponential(maxLength - toExponentialExcess > 0
                ? maxLength - toExponentialExcess
                : 1)
            : num.toExponential();
    else {
        return num;
    }
};
export const checkNumberLength = (item, schema) => {
    if (schema.type === "object") {
        Object.keys(item).map((i) => {
            var _a, _b, _c, _d;
            if ((((_a = schema.properties[i]) === null || _a === void 0 ? void 0 : _a.type) === "number" ||
                ((_b = schema.properties[i]) === null || _b === void 0 ? void 0 : _b.type) === "integer") &&
                item[i] !== null) {
                item[i] = typeof item[i] !== "number" ? Number(item[i]) : item[i];
                item[i] = setNumberToLength(item[i], (_c = schema.properties[i]) === null || _c === void 0 ? void 0 : _c.maxLength);
            }
            if (((_d = schema.properties[i]) === null || _d === void 0 ? void 0 : _d.type) === "object") {
                item[i] = checkNumberLength(item[i], schema.properties[i]);
            }
        });
    }
    return item;
};
//# sourceMappingURL=utils.js.map